"use client";

import React from "react";
export default class GoogleAdSense extends React.Component {
  componentDidMount() {
    if (typeof window !== "undefined") {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    }
  }

  render() {
    let adTest = process.env.ORION_ENV != "production" ? { "data-adtest": "on" } : {};

    return (
      <ins
        className="adsbygoogle"
        style={{ display: "block" }}
        data-ad-client="ca-pub-8178679793640375"
        data-ad-slot="4547199651"
        data-ad-format="auto"
        {...adTest}
        data-full-width-responsive="true"
      />
    );
  }
}
